// @ts-check
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Typography, Box, Grid } from '@material-ui/core';
import giftImage from 'assets/images/gift.png';
import Image from '../Image';
import GiftOptionsButton from '../GiftOptionsButton';
import ProductPrice from '../ProductPrice';
import ItemInfo from '../ItemInfo';

const ProductInfo = ({
  classes,
  productData,
  isBopsOrder,
  bopsAddress,
  orderConfirmationView,
  isReservationView,
  isGiftReceipt,
}) => {
  const {
    brandName,
    name,
    pimSkuId,
    imageUrl,
    color,
    size,
    availableQuantity,
    isDropship,
    bopsAvailability,
    currentPrice,
    originalPrice,
    isGiftWrappable,
    giftOptions,
    adjustedPrice,
    itemQty,
    price,
  } = productData;

  let displayPrice = currentPrice || originalPrice || price;
  if (typeof displayPrice === 'object') displayPrice = price?.orderPrice;

  // Parsing price as per BE request
  const retailPrice = parseFloat(displayPrice || '0').toFixed(2);
  const _originalPrice = originalPrice ? parseFloat(originalPrice).toFixed(2) : undefined;
  const productImage = isGiftReceipt && !imageUrl ? giftImage : imageUrl;

  const ITEM_DETAILS_MAP = [
    {
      value: color,
      label: 'Color',
    },
    {
      value: size,
      label: 'Size',
    },
    {
      value: orderConfirmationView ? itemQty.toString() : availableQuantity,
      label: 'Qty',
    },
  ];

  const renderErrorText = (text) => (
    <Typography color="error" paragraph className={classes.paddingBottom}>
      {text}
    </Typography>
  );

  const renderBopsText = () => {
    const defaultLocation = localStorage.getItem('lastBopsLocation');
    const storeNumber = Number(bopsAddress?.storeNum || defaultLocation);
    const inStock = bopsAvailability && bopsAvailability[storeNumber];

    return (
      <Typography variant="body2" color="textSecondary" data-testid="bops-text">
        {`Available for pickup ${inStock && Number(inStock) > itemQty ? 'today' : '3-7 days'}`}
      </Typography>
    );
  };

  return (
    <>
      <Grid container className={classes.gridContainer}>
        <Grid item className={classes.productImg}>
          <Image src={productImage} alt={brandName} userBrand="BG" data-testid="product-image" />
        </Grid>
        <Grid item className={classes.details}>
          <Typography variant="h5" paragraph className={classes.paddingBottom}>
            {brandName}
          </Typography>
          <Typography paragraph className={classes.paddingBottom}>
            {name}
          </Typography>
          <Typography color="textSecondary" className={classes.paddingBottom}>
            PIM SKU {pimSkuId}
          </Typography>
          {isBopsOrder && renderBopsText()}
          {availableQuantity === '0' && !orderConfirmationView && renderErrorText('Out of Stock')}
          {isDropship && renderErrorText('Ships from vendor')}
          <ItemInfo itemProperties={ITEM_DETAILS_MAP} alignValuesToLeft={isReservationView} />
        </Grid>
      </Grid>
      <Grid container className={cx(orderConfirmationView && '-withinOrderConfirmation')}>
        {orderConfirmationView && (
          <Box className={classes.giftOptionsContainer}>
            <GiftOptionsButton
              giftOptions={giftOptions}
              isOrderWrappable={isGiftWrappable}
              hideGiftOptions={orderConfirmationView}
            />
          </Box>
        )}
        <Box
          display="flex"
          justifyContent="flex-end"
          className={cx(classes.priceContainer, !orderConfirmationView && classes.priceFullWidth)}
        >
          {isReservationView ? (
            <> ${Number(currentPrice).toFixed(2)} </>
          ) : (
            <ProductPrice
              currencyCode="$"
              retailPrice={retailPrice}
              adjustedPrice={adjustedPrice}
              originalPrice={_originalPrice}
            />
          )}
        </Box>
      </Grid>
    </>
  );
};

ProductInfo.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string),
  productData: PropTypes.objectOf(PropTypes.any),
  bopsAddress: PropTypes.objectOf(PropTypes.any),
  isBopsOrder: PropTypes.bool,
  orderConfirmationView: PropTypes.bool,
  isReservationView: PropTypes.bool,
};

ProductInfo.defaultProps = {
  classes: {},
  productData: {},
  bopsAddress: {},
  isBopsOrder: false,
  orderConfirmationView: false,
  isReservationView: false,
};

export default ProductInfo;
